import * as components from './components';

export default [
    {
        path: '/costco-service-requests/:status?',
        component: components.CostcoServiceRequestsList,
        name: 'CostcoServiceRequestsList',
        meta: { admin: true }
    }
];


// WEBPACK FOOTER //
// ./ClientApp/app/costcoservicerequests/routes.js